module.exports = __webpack_public_path__ + "static/media/new.290df240.jpg";